@if (panelMode && !!childEntityModel) {
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        @if (!isLoading) {
          <span>
            <mat-chip-set aria-label="Entity count">
              <mat-chip class="title-chip">{{ (entities).length }}</mat-chip>
            </mat-chip-set>
          </span>
        }
        @if (isLoading) {
          <mat-progress-spinner [diameter]="20" mode="indeterminate"></mat-progress-spinner>
        }
        <span>{{ childEntityModel.title | translate }}</span>
      </mat-panel-title>
      <mat-panel-description></mat-panel-description>
    </mat-expansion-panel-header>
    <ng-container *ngTemplateOutlet="entityList"></ng-container>
  </mat-expansion-panel>
}

@if (!panelMode && !!childEntityModel) {
  <ng-container *ngTemplateOutlet="entityList"></ng-container>
}

<!-- Template for entity list and actions -->
<ng-template #entityList>
  <mat-selection-list #childSelect>
    @for (child of entities; track child) {
      @if (!childEntityModel.readonly) {
        <mat-list-option [value]="child" checkboxPosition="before"
          [attr.aria-label]="'Select ' + childEntityModel.title">
          <app-child-entity-display-resolver [childType]="childEntityModel.type"
            [displayComponentType]="childEntityModel.displayComponent" [displayField]="childEntityModel.display"
            [relation]="childEntityModel.relation" [resource]="child">
          </app-child-entity-display-resolver>
        </mat-list-option>
      }
      @if (childEntityModel.readonly) {
        <mat-list-item>
          <app-child-entity-display-resolver [childType]="childEntityModel.type"
            [displayComponentType]="childEntityModel.displayComponent" [displayField]="childEntityModel.display"
            [relation]="childEntityModel.relation" [resource]="child">
          </app-child-entity-display-resolver>
        </mat-list-item>
      }
    }
  </mat-selection-list>

  @if (!childEntityModel.readonly) {
    <div class="action-buttons">
      @if (!panelMode) {
        <button (click)="openAddDialog()" [color]="panelMode ? '' : 'primary'" mat-flat-button
          [attr.aria-label]="'Add ' + childEntityModel.title">
          {{ 'scheduler.general.add' | translate }} {{ childEntityModel.title | translate }}
        </button>
      }
      @if (panelMode) {
        <button (click)="openAddDialog()" mat-button [attr.aria-label]="'Add ' + childEntityModel.title">
          {{ 'scheduler.general.add' | translate }} {{ childEntityModel.title | translate }}
        </button>
      }
      @if (!panelMode) {
        <button (click)="deleteSelected()" [disabled]="childSelect.selectedOptions.selected.length===0"
          [color]="panelMode ? '' : 'warn'" mat-flat-button
          [attr.aria-label]="'Delete selected ' + childEntityModel.title">
          {{ 'scheduler.general.delete-selected' | translate }}
        </button>
      }
      @if (panelMode) {
        <button (click)="deleteSelected()" [disabled]="childSelect.selectedOptions.selected.length===0" mat-button
          [attr.aria-label]="'Delete selected ' + childEntityModel.title">
          {{ 'scheduler.general.delete-selected' | translate }}
        </button>
      }
    </div>
  }
</ng-template>
